import { getElementFromEvent } from '../utils';

export default class Anchors {
	constructor(el) {
		this.el = el;

		this.el.addEventListener('click', (e) => {
			const link = getElementFromEvent(e, 'a');

			if (!link) {
				return;
			}

			let [linkUri, linkHash] = link.href.split('#');
			let [currentUri, currentHash] = window.location.href.split('#');

			if (linkUri !== currentUri) {
				return;
			}

			if (linkHash == 'undefined') {
				return;
			}

			const el = this.el.querySelector(`#${linkHash}`);

			if (!el) {
				return;
			}

			e.preventDefault();

			window.scrollTo({
				top: el.getBoundingClientRect().top + window.scrollY - 60,
				behavior: 'smooth',
			});
		});
	}

	static init() {
		document.addEventListener('bless', (e) => {
			new Anchors(e.target);
		});
	}
}
